/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";
import SearchInput from "../../../components/Ui/Search";
import Pagination from "../../../components/Ui/Paging";
import { calculatePage } from "../../../utils/paging";

import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Create from "./Create";
import { IconPlus, IconEdit, IconTrash } from "../../../components/Ui/Icon";
import {
  adminGetListIndex,
  deleteIndex,
  deactiveIndex,
} from "../../../services/exIndex";
import ConfirmPopup from "../../../components/Ui/Confirm";

const List = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(new Date());

  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [selectIndex, setSelectedIndex] = useState(null);
  const [paginatedData, setPageData] = useState([]);

  const [isConfirm, setIsConfirm] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const initPaging = {
    page: parseInt(searchParams.get("page")) || 1,
    limit: parseInt(searchParams.get("limit")) || 10,
    sortBy: searchParams.get("sortBy") || "createdAt",
    sortType: searchParams.get("sortType") || "DESC",
    search: searchParams.get("search") || "",
    total: 0,
    totalPages: 0,
  };
  const [paging, setPaging] = useState(initPaging);

  const setQueryParams = (queryParams) => {
    const searchParams = new URLSearchParams();

    Object.keys(queryParams).forEach((key) => {
      searchParams.set(key, queryParams[key]);
    });

    navigate({ search: searchParams.toString() });
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const dataSubs = await adminGetListIndex(paging);
      setTimeout(() => {
        setData(dataSubs?.data?.data);
        setPaging((prev) => ({
          ...prev,
          total: dataSubs?.data?.data?.length,
          totalPages: calculatePage(dataSubs?.data?.data?.length, prev.limit),
        }));
      });

      setLoading(false);
    };
    fetchData();
    setTimeout(() => {
      setQueryParams(paging);
    });
  }, [refresh]);

  const filterData = () => {
    if (paging.search) {
      const filterd = data.filter((f) =>
        f.index_name.includes(paging.search.toLowerCase())
      );

      setPaging((prev) => ({
        ...prev,
        total: filterd?.length,
        totalPages: calculatePage(filterd?.length, prev.limit),
      }));

      return filterd;
    }

    setPaging((prev) => ({
      ...prev,
      total: data?.length,
      totalPages: calculatePage(data?.length, prev.limit),
    }));

    return data;
  };

  useEffect(() => {
    const startIndex = (paging.page - 1) * paging.limit;

    setPageData(filterData().slice(startIndex, startIndex + paging.limit));
  }, [
    data,
    paging.page,
    paging.limit,
    paging.sortBy,
    paging.sortType,
    paging.search,
    paging.total,
    paging.totalPages,
  ]);

  const callDeleteIndex = async () => {
    if (!selectIndex) return;
    setLoading(true);
    try {
      deleteIndex(selectIndex.index_name);

      setRefresh(new Date());
      setLoading(false);
      toast.success("Successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const callDeactiveIndex = async (item) => {
    if (!item) return;
    setLoading(true);
    try {
      await deactiveIndex({ index_name: item.index_name });

      setRefresh(new Date());
      setLoading(false);
      toast.success("Successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setPaging((prev) => ({
      ...prev,
      page,
    }));
  };

  const onSearch = (search) => {
    setPaging((prev) => ({
      ...prev,
      page: 1,
      search,
    }));
  };

  const handleOnChangeStatus = (item) => {
    if (item?.is_activated) {
      callDeactiveIndex(item);
    } else {
      setSelectedIndex(item);
      setIsOpenCreate(true);
    }
  };

  const dataSection = useMemo(() => {
    return (
      <table className="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3">
              STT
            </th>
            <th scope="col" className="px-6 py-3">
              Index Name
            </th>
            <th scope="col" className="px-6 py-3">
              Status
            </th>
            <th scope="col" className="px-6 py-3">
              Priority
            </th>
            <th scope="col" className="px-6 py-3 text-center">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {paginatedData?.map((item, index) => (
            <>
              <tr key={index} className="bg-white border-b ">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                >
                  {index + 1}
                </th>
                <td className="px-6 py-4">{item.index_name}</td>

                <td>
                  <label className="group inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      value=""
                      className="sr-only peer"
                      checked={item.is_activated}
                      onChange={(e) => handleOnChangeStatus(item)}
                    />
                    <span className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all peer-checked:bg-blue-600">
                      {item.is_activated && (
                        <span className="opacity-0 transition-all duration-300 group-hover:opacity-80 group-hover:[translate:-100%] inline-flex items-center  text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full ">
                          {item.is_activated}
                        </span>
                      )}
                      {!item.is_activated && (
                        <span className="opacity-0 transition-all duration-300 group-hover:opacity-80 group-hover:[translate:70%] inline-flex items-center  text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full ">
                          {item.is_activated}
                        </span>
                      )}
                    </span>
                  </label>
                </td>
                <td className="px-6 py-4">
                  <span>{item.priority}</span>
                </td>
                <td>
                  <div className="sm:col-span-1">
                    <button
                      disabled={loading}
                      type="button"
                      onClick={() => {
                        setSelectedIndex(item);
                        setIsOpenCreate(true);
                      }}
                      className="mr-2 inline-flex gap-2 text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-2.5 py-1.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      <IconEdit className="size-5 rotate-180" />
                      <span> Active</span>
                    </button>
                    {![0, 1].includes(item.priority) && (
                      <button
                        disabled={loading}
                        type="button"
                        onClick={() => {
                          setSelectedIndex(item);
                          setIsConfirm(true);
                        }}
                        className="inline-flex gap-2 text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-2.5 py-1.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        <IconTrash className="size-5" />
                      </button>
                    )}

                    {/* <input
                      // hidden
                      type="file"
                      placeholder="Upload Document"
                      // ref={fileInputRef}
                      onChange={handleUploadAvatar}
                      // accept="text/csv, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    /> */}
                  </div>
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    );
  }, [paginatedData, data]);

  const pagine = useMemo(() => {
    if (!paging.totalPages || paging.total <= paging.limit) return <></>;
    return (
      <Pagination
        totalPages={paging.totalPages}
        currentPage={paging.page}
        onPageChange={handlePageChange}
      />
    );
  }, [paging.page, paging.totalPages]);
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <div className="flex w-full justify-between items-center p-3 flex-wrap md:flex-nowrap">
        <h2 className="font-semibold text-3xl text-left rtl:text-right text-gray-900">
          Index Elastic Search
        </h2>
        <div className="inline-flex items-center gap-2">
          <a
            href="#create"
            onClick={(e) => setIsOpenCreate(true)}
            type="button"
            className="flex items-center p-2 text-sm font-medium h-full text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            <IconPlus />
            <span> Create</span>
          </a>
          <SearchInput className="md:mr-28" onSubmitSearch={onSearch} />
        </div>
      </div>
      {dataSection}
      {pagine}
      {loading && <LoadingOverlay />}

      {isOpenCreate && (
        <Create
          item={selectIndex}
          onSubmited={(e) => {
            handlePageChange(1);
            setRefresh(new Date());
            setIsOpenCreate(false);
            setSelectedIndex(null);
          }}
          togglePopup={() => {
            setSelectedIndex(null);
            setIsOpenCreate(false);
          }}
        />
      )}

      <ConfirmPopup
        isOpen={isConfirm}
        handleClick={() => {
          setIsConfirm(false);
          callDeleteIndex();
        }}
        title="Are you sure you want to do this action?"
        shortTitle="This action cannot be undone."
        togglePopup={() => setIsConfirm(false)}
      />
    </div>
  );
};

export default List;
